(function () {
  function getProductCard(element) {
    if (!element) return null;
    return element.closest('product-card') || element.closest('.product-card');
  }

  function submitForm(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function getVariantsData(form) {
    var scriptEl = form.querySelector('[data-role="quick-add-variants-json"]');
    if (!scriptEl) return [];

    try {
      var json = scriptEl.textContent || scriptEl.innerText || '[]';
      return JSON.parse(json);
    } catch (e) {
      console.warn('Quick add: no se pudo parsear el JSON de variantes', e);
      return [];
    }
  }

  function closeAllQuickAddCards(exceptCard) {
    var openCards = document.querySelectorAll(
      '.product-card--quick-add-open, .product-card--quick-add-variants'
    );

    for (var i = 0; i < openCards.length; i++) {
      var card = openCards[i];
      if (exceptCard && card === exceptCard) continue;
      card.classList.remove('product-card--quick-add-variants');
      card.classList.remove('product-card--quick-add-open');
    }
  }

  function updateVariantFromSelections(form) {
    var hiddenInput = form.querySelector('[data-role="quick-add-variant-id"]');
    var submitButton = form.querySelector('.quick-add-card__button--submit');
    if (!hiddenInput || !submitButton) return;

    var optionBlocks = form.querySelectorAll('.quick-add-card__option');
    var selectionsByPos = {};
    var orderedPositions = [];

    for (var i = 0; i < optionBlocks.length; i++) {
      var block = optionBlocks[i];
      var pos = block.getAttribute('data-option-position');
      orderedPositions.push(pos);

      var selectedBtn = block.querySelector('.quick-add-card__variant-button.is-selected');
      if (selectedBtn) {
        selectionsByPos[pos] = selectedBtn.getAttribute('data-option-value');
      }
    }

    // ¿Todas las opciones tienen un valor seleccionado?
    var allSelected = true;
    for (var j = 0; j < orderedPositions.length; j++) {
      var p = orderedPositions[j];
      if (!selectionsByPos[p]) {
        allSelected = false;
        break;
      }
    }

    var variants = getVariantsData(form);

    if (!allSelected) {
      hiddenInput.value = '';
      submitButton.disabled = true;
      submitButton.classList.add('quick-add-card__button--loading');
      return;
    }

    // Construimos array ordenado de valores [Talla, Color, ...]
    var requiredOptions = [];
    for (var k = 0; k < orderedPositions.length; k++) {
      requiredOptions.push(selectionsByPos[orderedPositions[k]]);
    }

    // Buscamos la variante que encaje con esos valores
    var matchingVariant = null;

    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      if (!variant.options || variant.options.length !== requiredOptions.length) continue;

      var match = true;
      for (var x = 0; x < requiredOptions.length; x++) {
        if (variant.options[x] !== requiredOptions[x]) {
          match = false;
          break;
        }
      }

      if (match) {
        matchingVariant = variant;
        break;
      }
    }

    if (!matchingVariant) {
      hiddenInput.value = '';
      submitButton.disabled = true;
      submitButton.classList.add('quick-add-card__button--loading');
      return;
    }

    hiddenInput.value = String(matchingVariant.id);

    if (matchingVariant.available) {
      submitButton.disabled = false;
      submitButton.classList.remove('quick-add-card__button--loading');
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('quick-add-card__button--loading');
    }
  }

  function handleVariantButtonClick(button) {
    var form = button.closest('.quick-add-card__variants-form');
    if (!form) return;

    var optionPosition = button.getAttribute('data-option-position');
    var wasSelected = button.classList.contains('is-selected');

    // Si estaba seleccionada, des-seleccionamos
    if (wasSelected) {
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    } else {
      // Des-seleccionamos las otras del mismo grupo
      var siblings = form.querySelectorAll(
        '.quick-add-card__variant-button[data-option-position="' + optionPosition + '"]'
      );
      for (var i = 0; i < siblings.length; i++) {
        siblings[i].classList.remove('is-selected');
        siblings[i].setAttribute('aria-pressed', 'false');
      }

      // Seleccionamos esta
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    }

    updateVariantFromSelections(form);
  }

  function handleMobileTrigger(trigger) {
    var card = getProductCard(trigger);
    if (!card) return;

    var hasSingleVariant = trigger.getAttribute('data-single-variant') === 'true';

    if (hasSingleVariant) {
      // Añadir directo
      var form = card.querySelector('.quick-add-card__primary-form');
      submitForm(form);
    } else {
      // Cerrar otros quick-add y abrir este
      closeAllQuickAddCards(card);
      card.classList.add('product-card--quick-add-open', 'product-card--quick-add-variants');
    }
  }

  function handleOpenVariants(button) {
    var card = getProductCard(button);
    if (!card) return;

    // Cerrar otros quick-add y abrir este
    closeAllQuickAddCards(card);
    card.classList.add('product-card--quick-add-open', 'product-card--quick-add-variants');
  }

  function handleBack(button) {
    var card = getProductCard(button);
    if (!card) return;

    card.classList.remove('product-card--quick-add-variants');

    // En mobile también cerramos el overlay completo
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      card.classList.remove('product-card--quick-add-open');
    }
  }

  document.addEventListener('click', function (event) {
    // Botón flotante móvil
    var mobileTrigger = event.target.closest('.quick-add-card__mobile-trigger');
    if (mobileTrigger) {
      handleMobileTrigger(mobileTrigger);
      return;
    }

    // Botón "Seleccionar opciones"
    var openVariantsBtn = event.target.closest('.quick-add-card__open-variants');
    if (openVariantsBtn) {
      handleOpenVariants(openVariantsBtn);
      return;
    }

    // Botón de valor de opción (talla, color, etc.)
    var variantButton = event.target.closest('.quick-add-card__variant-button');
    if (variantButton) {
      handleVariantButtonClick(variantButton);
      return;
    }

    // Botón "Volver"
    var backBtn = event.target.closest('.quick-add-card__back');
    if (backBtn) {
      handleBack(backBtn);
      return;
    }

    // --- Cerrar al hacer click fuera del quickadd de opciones ---

    // Si el click es dentro del overlay, no hacemos nada
    if (event.target.closest('.quick-add-card__overlay')) {
      return;
    }

    // Si no es dentro del overlay, cerramos cualquier card que tenga el quickadd abierto
    closeAllQuickAddCards(null);
  });

  // Cerrar quick-add al enviar el formulario (añadir al carrito)
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.quick-add-card__variants-form, .quick-add-card__primary-form');
    if (!form) return;

    var card = getProductCard(form);
    if (!card) return;

    // Cerramos todos los quick-add (incluido este)
    closeAllQuickAddCards(null);
  });

  // Inicializar estado del botón submit según el hidden + disponibilidad
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('.quick-add-card__variants-form');

    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var hiddenInput = form.querySelector('[data-role="quick-add-variant-id"]');
      var submitButton = form.querySelector('.quick-add-card__button--submit');
      if (!hiddenInput || !submitButton) continue;

      var variants = getVariantsData(form);
      var currentId = hiddenInput.value;
      var found = null;

      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === String(currentId)) {
          found = variants[j];
          break;
        }
      }

      if (!found || !found.available) {
        submitButton.disabled = true;
        submitButton.classList.add('quick-add-card__button--loading');
      } else {
        submitButton.disabled = false;
        submitButton.classList.remove('quick-add-card__button--loading');
      }
    }
  });
})();
